import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { TranslatesService } from '../../translates';
import { LocationManagerService } from '@cakeiteasy/web-utils';
import { DOMAIN_LANGUAGE_CODE_MAP } from '@translates/translates.service';
import { catchError } from 'rxjs/operators';


@Injectable()
export class LocaleHttpInterceptor implements HttpInterceptor {
  public locale: string;

  constructor(private _translation: TranslatesService,
              private _locationManager: LocationManagerService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const domain = this._locationManager.getDomainName();
    let locale = DOMAIN_LANGUAGE_CODE_MAP[domain];

    if (locale !== 'en') {
      locale += ', en';
    }

    req = req.clone({
      setHeaders: {
        'Accept-Language': locale
      }
    });

    return next.handle(req)
      .pipe(catchError((error) => {
        return throwError(error);
      }));
  }
}
